import { IConfigsType } from '../../types'

const fwOriginalStorePagesConfig: IConfigsType = {
  'fw_wingstop-store-base-r3d9tnva': {
    '/:brand/delivery': {},
  },
}

export default fwOriginalStorePagesConfig
